import React from "react";
import { Header_panel } from "../Useful/Useful";
import { Button, Form } from "reactstrap";
import "../Useful/useful.css";

export default class AddSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
    };

    if (props.fillData.id) {
      this.state = props.fillData;
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSubmit(event) {
    event.preventDefault();
    this.props.onFormSubmit(this.state);
    this.setState({ name: "" });
  }

  render() {
    return (
      <div className="col-lg-12 mypanel shadow">
        <Header_panel
          title="افزودن دسته بندی"
          idMenu="#navbarToggleExternalContentSettingAdd"
        />
        <div className="pos-f-t">
          <div className="collapse" id="navbarToggleExternalContentSettingAdd">
            <Form onSubmit={this.handleSubmit}>
              <div className="row p-4">
                <div className="col-lg-4">
                  <div className="form-group textg">
                    <label className="control-label" htmlFor="first_name">
                      * نام دسته بندی
                    </label>
                    <input
                      value={this.state.name}
                      onChange={this.handleChange("name")}
                      className="contactInput form-control"
                      name="title"
                      placeholder="نام دسته بندی..."
                    />
                  </div>
                </div>
              </div>
              <Button type="submit" color="primary" id="regProdbtn">
                ذخیره
              </Button>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
